import React from 'react'
import { Security } from 'src/shared/security.dto'

export interface Props {
  security: Pick<Security, 'name' | 'ticker' | 'exchangeCode' | 'image'>
  width: number
  height: number
}

export const SecurityImage: React.FC<Props> = ({ security, width, height }) => {
  if (!security.image) {
    return null
  }
  return (
    <img
      width={width}
      height={height}
      src={security.image}
      loading={'lazy'}
      alt={`Picture of ${security.name} logo`}
    />
  )
}
